import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";

const { size } = typography;
const { text } = colors;

const dialogContentText = {
  styleOverrides: {
    root: {
      fontSize: size.md,
      color: text!.main,
    },
  },
};

export default dialogContentText;
